import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useProviderPackage, { generateUrls } from '@hooks/useProviderPackage'

import type { ProviderPackageModel } from '@models/types'

type ProviderPackageListItemProps = {
  providerPackage: ProviderPackageModel,
}

const ProviderPackageListItem = (props: ProviderPackageListItemProps) => {
  const { providerPackage } = props

  const {
    providerPackage: {
      title,
    },
  } = useProviderPackage(providerPackage)

  const { editProviderPackageUrl } = generateUrls(providerPackage)

  return (
    <DashboardModuleListItem title={title}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editProviderPackageUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
        // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default ProviderPackageListItem
